import n from "./index4.mjs";
import { staticRenderFns as o, render as r } from "./index5.mjs";
import l from "./index6.mjs";
const e = {};
var s = /* @__PURE__ */ l(
  n,
  r,
  o,
  !1,
  _,
  null,
  null,
  null
);
function _(c) {
  for (let t in e)
    this[t] = e[t];
}
const f = /* @__PURE__ */ function() {
  return s.exports;
}();
export {
  f as default
};
//# sourceMappingURL=index2.mjs.map
